module.exports = __webpack_public_path__ + "static/5-8bea7e58087e99060b6102397dd1a4c5.jpg";